import { useEffect } from 'react';

import { loadMemberships } from '../../store/workspaceSettingsSlice';

import { Box } from '@components/Box';
import { useAppDispatch, useAppSelector } from '@store/hooks';

const WorkspaceList: React.FC = () => {
  const dispatch = useAppDispatch();
  const { memberships, isLoading, error } = useAppSelector(
    (s) => s.settingsWorkspaces
  );

  useEffect(() => {
    dispatch(loadMemberships());
  }, [dispatch]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <span className="text-sm text-gray-500">Loading workspaces...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-sm text-red-600 bg-red-50 rounded-md">
        {error}
      </div>
    );
  }

  return (
    <Box>
      <div className="flex items-start flex-col space-y-4 p-4">
        <h3 className="text-lg font-semibold text-gray-900">Workspaces</h3>

        {memberships.length === 0 ? (
          <p className="text-sm text-gray-500">No workspaces found.</p>
        ) : (
          <ul className="divide-y divide-gray-200">
            {memberships.map((m) => (
              <li
                key={m.membershipId}
                className="py-3 flex items-start justify-between"
              >
                <div className="flex flex-col space-y-1">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-medium text-gray-900">
                      {m.companyName ?? m.tenantName}
                    </span>
                    {m.isActive && (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                        Active
                      </span>
                    )}
                  </div>
                  {m.companyName && (
                    <span className="text-xs text-gray-500">
                      {m.tenantName}
                    </span>
                  )}
                  {m.applicationRole && (
                    <span className="text-xs text-gray-500">
                      Role: {m.applicationRole}
                    </span>
                  )}
                  {m.workspaceRoles.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1">
                      {m.workspaceRoles.map((role) => (
                        <span
                          key={role}
                          className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-700"
                        >
                          {role}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <span className="text-xs text-gray-400 capitalize">
                  {m.contextType}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Box>
  );
};

export default WorkspaceList;
